/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { useTheme } from '@emotion/react'

import { IconProps } from '../../types'

export const Close = ({ fill, size = 11, strokeWidth = 1, ...rest }: IconProps) => {
  const { colors } = useTheme()
  fill = fill ?? colors.text
  return (
    <svg
      fill="none"
      height={size}
      viewBox="0 0 11 11"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <line
        stroke={fill}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
        x1="0"
        x2="11"
        y1="0"
        y2="11"
      />
      <line
        stroke={fill}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
        x1="11"
        x2="0"
        y1="0"
        y2="11"
      />
    </svg>
  )
}
